import { getDataFromWordpress } from "./../utils/getDataFromWordpress";
import { useTranslation } from "react-i18next";
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import vid_osm from "./../assets/SQ2_Logo_Ciano.mp4";

export const DataContext = React.createContext();

const DataProvider = ({ children }) => {
	const [data, setData] = React.useState();
	const [error, setError] = React.useState(null);
	const { i18n } = useTranslation();
	const [isLoading, setIsLoading] = React.useState(true);
	const cache = React.useRef({});

	React.useEffect(() => {
		const lang = i18n["language"];

		if (cache.current[lang]) {
			setData(cache.current[lang]);
			setIsLoading(false);
			return;
		}

		setIsLoading(true);
		setError(null);
		getDataFromWordpress(lang)
			.then((data) => {
				cache.current[lang] = data;
				setData(data);
			})
			.catch((err) => setError(err))
			.finally(() => setIsLoading(false));
	}, [i18n["language"]]);

	if (error) {
		return (
			<DataContext.Provider value={{}}>
				<div className='loader-error'>
					<p>Impossibile caricare i contenuti. Ricarica la pagina.</p>
				</div>
			</DataContext.Provider>
		);
	}

	return (
		<DataContext.Provider value={{ ...data }}>
			{children}
			<AnimatePresence>
				{isLoading && (
					<motion.div
						className='loader'
						initial={{ opacity: 1 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}>
						<video autoPlay muted loop playsInline>
							<source src={vid_osm} type='video/mp4' />
						</video>
					</motion.div>
				)}
			</AnimatePresence>
		</DataContext.Provider>
	);
};

export default DataProvider;
